import React from 'react';
import StyledField from "../../../components/StyledField/StyledField";
import FormCreditFields from "./FormCreditFields";
import FileUpload from "../../../components/FileUpload/FileUpload";
import ColorSelect from "../../../components/ColorSelect/ColorSelect";
import { Field } from "formik";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Well from '../../../components/Well';

class Credits extends React.Component {
  render() {
    const { activeTab, directory, firebase, values, setFieldValue } = this.props;

    return (
        <section className={ activeTab === 'credits' ? 'tab-content is-enabled' : 'tab-content' }>
          <div className="field-group">
            <h3>Credits</h3>
            <Field component={ StyledField } name="credits.title" label="Title" />
            <Checkbox label="Show title on credits slide" name="credits.enabled" />
            <FormCreditFields values={ values } setFieldValue={ setFieldValue } />
            <Well className="margin--top">
              <div className="grid margin--top">
                <div className="grid-item margin--top">
                  <FileUpload firebase={ firebase }
                              directory={ directory }
                              name="credits.background.backgroundImage.url"
                              label="Select a Background Image"
                              hint="File should be 800x800 pixels or larger."
                  />
                </div>
                <div className="grid-item">
                  { values.credits.background.backgroundImage.url &&
                  <img src={ values.credits.background.backgroundImage.url }
                       style={ { width: '200px', height: 'auto' }}
                       alt="Credit background"
                  /> }
                </div>
              </div>
              <div className="field-group margin--top-doubled">
                <ColorSelect name="credits.background.backgroundColor" label="Background Color" />
              </div>
            </Well>
          </div>
        </section>);
    }
}


export default Credits;



// WEBPACK FOOTER //
// ./src/containers/add/Credits/index.js